// extracted by mini-css-extract-plugin
module.exports = {"carouselContent":"top3-carousel_carouselContent__uqM5x","avatarContainer":"top3-carousel_avatarContainer__2ENYN"};